import { render, staticRenderFns } from "./SearchCustomers.vue?vue&type=template&id=6b142797&scoped=true"
import script from "./SearchCustomers.vue?vue&type=script&lang=js"
export * from "./SearchCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b142797",
  null
  
)

export default component.exports